import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ThreePillarsSection from './components/ThreePillarsSection';
import AboutSection from './components/AboutSection';
import WhyTherapistSection from './components/WhyTherapistSection';
import PhilosophySection from './components/PhilosophySection';
import DifferenceSection from './components/DifferenceSection';
import FutureSection from './components/FutureSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import FlowSection from './components/FlowSection';
import VisitSection from './components/VisitSection';
import MessageSection from './components/MessageSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ThreePillarsSection />
      <WhyTherapistSection />
      <PhilosophySection />
      <DifferenceSection />
      <FutureSection />
      <ServicesSection />
      <PricingSection />
      <FlowSection />
      <VisitSection />
      <MessageSection />
      <ContactSection />
      <Footer />
    </div>
  );
}